/* Окно «Группа · Имя» (прототип client.html, groupPick): клиент в одной группе или ни в какой.
   Открывается из ячейки «Группа» в списке клиентов и из шапки карточки клиента. */
import { trpc } from '@tg/app-core';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useGroups } from '../lib/data';
import { plural } from '../lib/format';
import { ICON } from './icons';
import { Modal } from './Modal';
import { toast } from './Toast';

export function GroupPick({ client, onClose }: { client: { id: string; name: string; groupId: string | null }; onClose: () => void }) {
  const gs = useGroups().data || [];
  const was = client.groupId || '';
  const [pick, setPick] = useState(was);
  const utils = trpc.useUtils();
  const set = trpc.trainer.setClientGroup.useMutation();
  const name = (id: string) => gs.find((g) => g.id === id)?.name || '';
  const sum =
    pick === was
      ? ''
      : [was ? `Будущие тренировки группы «${name(was)}» у клиента уберутся, прошедшие останутся.` : '', pick ? `Тренировки группы «${name(pick)}» встанут клиенту с сегодняшнего дня.` : ''].filter(Boolean).join(' ');
  const opt = (id: string, n: string, d: string, av: React.ReactNode) => (
    <button key={id || 'none'} className={'cl' + (pick === id ? ' on' : '')} onClick={() => setPick(id)}>
      <span className="box rd">
        <ICON.chk />
      </span>
      <span className="av">{av}</span>
      <span className="who">
        <b>{n}</b>
        <s>{d}</s>
      </span>
    </button>
  );
  const save = () => {
    if (pick === was) return onClose();
    set.mutate(
      { clientId: client.id, groupId: pick || null },
      {
        onSuccess: () => {
          utils.trainer.clients.invalidate();
          utils.trainer.client.invalidate({ id: client.id });
          utils.trainer.groups.invalidate();
          utils.trainer.days.invalidate();
          toast(pick ? `Клиент в группе «${name(pick)}»` : `Клиент убран из группы «${name(was)}»`);
          onClose();
        },
        onError: (e) => toast(e.message || 'Не сохранилось'),
      },
    );
  };
  return (
    <Modal
      title={'Группа · ' + client.name}
      onClose={onClose}
      foot={
        <>
          <span className="sp"></span>
          <button className="btn gh" onClick={onClose}>
            Отмена
          </button>
          <button className="btn" disabled={set.isPending} onClick={save}>
            Сохранить
          </button>
        </>
      }
    >
      <div className="gpick">
        {gs.map((g) => opt(g.id, g.name, g.members.length + ' ' + plural(g.members.length, 'участник', 'участника', 'участников') + (g.about ? ' · ' + g.about : ''), <ICON.grpSm />))}
        {opt('', 'Без группы', 'Тренировки только личные', '—')}
      </div>
      {sum && <div className="hint">{sum}</div>}
      {!gs.length && (
        <div className="hint">
          Групп пока нет — создайте её в разделе <Link to="/groups">Группы</Link>.
        </div>
      )}
    </Modal>
  );
}
